import aboutImg from '../assets/img/about-img.png';
import map1 from '../assets/img/c1.png';
import map2 from '../assets/img/c2.png';
import map3 from '../assets/img/c3.png';
import map4 from '../assets/img/c4.png';
import Meta from '../components/Meta'

import SectionLogin from "../components/SectionLogin";

import {userLoginKey} from "../config";
import {useEffect, useState} from "react";
import {postUser} from "../utils/api";

const Home = () => {
  const [userLogin, setUserLogin] = useState(false)
  useEffect(() => {
    if (sessionStorage.getItem(userLoginKey)) {
      setUserLogin(true)
    }
  }, [])

  const handleOnLoad = () => {
    const postUserObj = {
      "roleId": 0
    }
    postUser(postUserObj).then();
  }

  return (
    <main id="main">
      <Meta title="首頁"/>
      <section id="about" className="about section-bg">
        <div className="container"  onLoad={() => handleOnLoad()}>
          <div className="row justify-content-between">
            <div className="col-lg-4 d-flex align-items-center justify-content-center about-img">
              <img src={aboutImg} className="img-fluid" alt="" data-aos="zoom-in" />
            </div>
            <div className="col-lg-7 pt-5 pt-lg-0">
              <h2 data-aos="fade-up">金檢學堂</h2>
              <div className="row">
                <div className="col-md-6" data-aos="fade-up" data-aos-delay="100">
                  <i className="bx bx-cube-alt" title="建置目的"></i>
                  <h3>建置目的</h3>
                  <p>本學習專區為向金融機構之稽核人員、對金融檢查有興趣者及金檢人員宣導金檢相關知識、建立金融檢查之基本觀念。
                    本局每年配合法規變動及檢查發現增修相關課程教育內容，並不定期新增課程單元，於年底前將增修課程內容公告上網，
                    期透過豐富、專業之課程說，引導瀏覽者輕鬆踏入金檢知識領域。</p>
                </div>
                <div className="col-md-6" data-aos="fade-up" data-aos-delay="200">
                  <i className="bx bx-receipt" title="重要訊息"></i>
                  <h3>重要公告</h3>
                  <p>
                    114年已於「金檢學堂」於「保險業資金運用」主題項下新增「專案運用公共投資業務」1個課程單元。<br/>
                    另配合法規變動(本次課程修正基準日為2025年6月30日)及檢查實務增修原有15個主題中之26個課程單元相關教材內容，歡迎指教。
                  </p>
                </div>
              </div>
            </div>
          </div>

        </div>
      </section>

      <a className="accesskey" href="#aC" id="aC" accessKey="C" title="中間主要內容區，此區塊列有本網站的主要內容" tabIndex="1">:::</a>
      {userLogin ? null : <SectionLogin/>}
      <section id="hero" className="hero d-flex align-items-center section-bg">
        <div className="container">
          <div className="section-title">
            <h2>金檢課程學習地圖</h2>
              <h3>本園區提供17站探索之旅，請循序漸進體驗</h3>
          </div>
          <div className="row gy-5">
            <div className="d-flex justify-content-center hero-img" >
              {userLogin ?
                <a href="/classFirst" title="前往課程列表" tabIndex="1">
                  <img src={map1} className="img-fluid animated" alt="學習地圖1-5 存款業務、洗錢防制、內部管理、授信業務、投資業務"/>
                </a>
                :
                <img src={map1} className="img-fluid animated" alt="學習地圖1-5 存款業務、洗錢防制、內部管理、授信業務、投資業務"/>
              }
            </div>
            <div className="d-flex justify-content-center hero-img">
              {userLogin ?
                <a href="/classFirst" title="前往課程列表" tabIndex="1">
                  <img src={map2} className="img-fluid animated" alt="學習地圖6-10 信託業務、金融商品銷售、資訊作業、保險招攬、證券承銷"/>
                </a>
                :
                <img src={map2} className="img-fluid animated" alt="學習地圖6-10 信託業務、金融商品銷售、資訊作業、保險招攬、證券承銷"/>
              }
            </div>
            <div className="d-flex justify-content-center hero-img">
              {userLogin ?
                <a href="/classFirst" title="前往課程列表" tabIndex="1">
                  <img src={map3} className="img-fluid animated" alt="學習地圖11-15 核保理賠、投資型保險商品、證券經紀、保險資金運用、保險業收費及佣金"/>
                </a>
                :
                <img src={map3} className="img-fluid animated" alt="學習地圖11-15 核保理賠、投資型保險商品、證券經紀、保險資金運用、保險業收費及佣金"/>
              }
            </div>
            <div className="d-flex justify-content-center hero-img">
              {userLogin ?
                <a href="/classFirst" title="前往課程列表" tabIndex="1">
                  <img src={map4} className="img-fluid animated" alt="學習地圖16-17 票券承銷業務、數位金融業務"/>
                </a>
                :
                <img src={map4} className="img-fluid animated" alt="學習地圖16-17 票券承銷業務、數位金融業務"/>
              }
            </div>
          </div>
        </div>
      </section>

    </main>

  )
}

export default Home
